
import {
  computed,
  defineComponent,
  onMounted,
  onBeforeUnmount,
  reactive,
  ref,
  watch,
  onBeforeMount,
} from "vue";
import { StepperComponent } from "@/assets/ts/components/_StepperComponent";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import * as Yup from "yup";
import moment from "moment";
import { ElementAnimateUtil } from "../../../assets/ts/_utils";
import { useStore } from "vuex";
import { useLazyQuery, useMutation, useQuery } from "@vue/apollo-composable";
import FormTextarea from "@/components/forms/Textarea.vue";
import FormTextinput from "@/components/forms/Textinput.vue";
import FormDropdown from "@/components/forms/Dropdown.vue";
import FormCheckbox from "@/components/forms/Checkbox.vue";
import {
  naikPangkatBorangView,
  naikPangkatMohonCreate,
  naikPangkatMohonCheck,
  naikPangkatMohonDrafCheck,
  naikPangkatMohonDrafCheck_V2,
  naikPangkatMohonUpdate,
} from "@/apollo/perkhidmatan/naikpangkat";
import { useRoute, useRouter } from "vue-router";
import {
  comboBorangPerkhidmatan,
  comboNegeri,
} from "@/apollo/pentadbiran/combo";
import { Field, Form } from "vee-validate";
import { WordArray } from "crypto-ts/src/lib/WordArray";
import { penggunaProfilHRMIS } from "@/apollo/perkhidmatan/naikpangkat";
import axios from "axios";
import FileField from "@/components/forms/FileField.vue";
import { listDaerah } from "@/apollo/pentadbiran/daerah";
import { SwalError, SwalInfo, SwalWarning } from '@/core/helpers/swal_helper';
import BorangPmkKnpFormPegawaiPsmComponent from "./components/BorangPMKKNP-form-pegawai-psm.vue";

import { apolloClient } from "@/apollo";
import VueSelect from 'vue-select';
import "vue-select/dist/vue-select.css";

type sijilType = 'sijilMIA' | 'sijilBadanIkhtisas'

export default defineComponent({
  name: "Borang-pemangkuan-akauntan",
  components: {
    FormTextarea,
    FormTextinput,
    FormDropdown,
    FormCheckbox,
    Form,
    FileField,
    BorangPmkKnpFormPegawaiPsmComponent,
    VueSelect,
  },
  data() {
    return {
      inputIC: "",
      inputName: "",
      inputNum: "",
      inputEmel: "",
      inputJantina: "",
      item: 1,
      count: 1,
      total: 1,
      box2: false,
      box3: false,
      box4: false,
      box5: false,
      slot2: false,
      slot3: false,
      slot4: false,
      slot5: false,
      selectCuti: "",
      selectIsy: "",
      selectTata: "",
      pinjaman: false,
      persaraan: false,

      listPsmMaklumat: [] as any[],
      fetchedDaerahList: [] as any[],
      showDaerahBertugas: false,
    };
  },
  computed: {
    styleDaerahBertugas(){
        if(this.showDaerahBertugas == true) {
            const icon : any = this.$refs.tooltipIcon;
            return {
            position: 'absolute',
            top: (icon.offsetTop - 50) + 'px',
            left: (icon.offsetLeft) + 'px',
            };
        }
        return {
            display: 'none',
        };
    },
    bangsaOptions() {
      const self = this as any;
      return self.getDropdownOptions(
        self.combo.bangsa.slice().sort((a, b) => a.kod.localeCompare(b.kod)),
        self.form.bangsa
      );
    },
    agamaOptions() {
      const self = this as any;
      return self.getDropdownOptions(
        self.combo.agama.slice().sort((a, b) => a.kod.localeCompare(b.kod)),
        self.form.agama
      );
    },
    statusPerkahwinanOptions() {
      const self = this as any;
      return self.getDropdownOptions(
        self.combo.status_perkahwinan.slice().sort((a, b) => a.kod.localeCompare(b.kod)),
        self.form.status_perkahwinan
      );
    },
    negeriOptions() {
      const self = this as any;
      return self.combo.negeri.slice().sort((a, b) => a.kod.localeCompare(b.kod));
    },
    kementerianOptions() {
      const self = this as any;
      return self.combo.kementerian
        .filter(k => k.label.toUpperCase().startsWith("KEMENTERIAN"))
        .sort((a, b) => a.label.localeCompare(b.label));
    },
  },
  methods: {
    findLabel(id, combo) {
      let label = "";
      if (combo != null) {
        combo.forEach((element) => {
          if (id == element.value) {
            label = element.label;
          }
        });
      }
      return label;
    },
    formatDate(date) {
      moment.locale("ms");

      return date ? moment(date).format("DD MMMM YYYY") : "-";
    },
    increment() {
      if (this.item != 5) {
        this.item++;
      }
      switch (this.item) {
        case 2:
          this.box2 = true;
          break;
        case 3:
          this.box3 = true;
          break;
        case 4:
          this.box4 = true;
          break;
        case 5:
          this.box5 = true;
          break;
        default:
          break;
      }
    },
    decrement() {
      if (this.item != 1) {
        this.item--;
      }
      this.box5 = false;
      switch (this.item) {
        case 2:
          this.box2 = false;
          break;
        case 3:
          this.box3 = false;
          break;
        case 4:
          this.box4 = false;
          break;
        case 5:
          this.box5 = false;
          break;
        default:
          break;
      }
    },
    plus() {
      if (this.count != 5) {
        this.count++;
      }
      switch (this.count) {
        case 2:
          this.slot2 = true;
          break;
        case 3:
          this.slot3 = true;
          break;
        case 4:
          this.slot4 = true;
          break;
        case 5:
          this.slot5 = true;
          break;
        default:
          break;
      }
    },
    minus() {
      if (this.count != 1) {
        this.count--;
      }
      this.slot5 = false;

      switch (this.count) {
        case 2:
          this.slot2 = false;
          break;
        case 3:
          this.slot3 = false;
          break;
        case 4:
          this.slot4 = false;
          break;
        case 5:
          this.slot5 = false;
          break;
        default:
          break;
      }
    },
    psmBahagianChanged(id: number){
      console.log('borang pmk knp, psm bahagian changed', id);
      this.form.psm_bahagian_id = id;
    },
    listPsmMaklumatChanged(data:any){
      console.log('list psm maklumat changed', data);
      this.listPsmMaklumat = data;
    },
    getDropdownOptions(comboList, currentValue) {
      if (!this.isEditable) return [];
      const options = [...comboList];
      // if (currentValue && !options.includes(currentValue)) {
      //   options.unshift(`${currentValue} (Tidak Dalam Senarai)`);
      // }
      return options;
    },
  },
  setup() {
    const isOpen1 = ref(false);
    const isOpen2 = ref(false);

    const _stepperObj = ref<StepperComponent | null>(null) as any;
    const checkedPengakuan = ref([]);
    const BorangPerkhidmatan = ref<HTMLElement | null>(null);
    const store = useStore();
    const perakuan = ref(["", "", ""]);
    const isPMK = ref(false);
    const jantina = ref(false);
    const ifJenisPersaraan = ref(false);
    const combo = reactive({
      kementerian: [{ value: "", label: "" }],
      negeri: [{ value: "", label: "", kod: "" }],
      // bangsa: [{ value: "", label: "" }],
      // agama: [{ value: "", label: "" }],
      bangsa: [{ value: "", label: "", kod: "" }],
      agama: [{ value: "", label: "", kod: "" }],
      jabatan: [{ value: "", label: "" }],
      // status_perkahwinan: [{ value: "", label: "" }],
      status_perkahwinan: [{ value: "", label: "", kod: "" }],
    });
    const variablesMohon = reactive({
      pengguna_id: 0,
      naik_pangkat_id: 0,
      status_permohonan: "DRAF",
    });
    const currentUser = store.getters.currentUser;
    const currentStepIndex = ref(0);
    const is_allowed = ref(false);
    let form = reactive({
      id: 0,
      jabatan_bertugas_semasa: '',
      naik_pangkat_id: 0,
      pengguna_id: 0,
      tarikh_masa_hantar: new Date(),
      no_kad_pengenalan: "",
      status_permohonan: "",
      jantina: "",
      nama: "",
      umur: "",
      no_telefon_bimbit: "",
      emel: "",
      tarikh_lahir: "1950-01-01",
      bangsa: "" as any,
      agama: "" as any,
      alamat: "",
      tempat_tinggal_negeri: "" as any,
      poskod: "",
      status_perkahwinan: "" as any,
      jawatan_hakiki: "",
      gred: "",
      gaji_pokok: "",
      tarikh_lantikan_sekarang: "",
      tarikh_sah_sekarang: "",
      tarikh_naik_pangkat_terakhir: "",
      tarikh_memangku: "",
      tarikh_persaraan: "",
      kementerian: "" as any,
      kementerianObj: {
        id: 0,
        nama_kementerian: "",
      },
      agensiObj: {
        id: 0,
        nama_agensi: "",
      },
      agensi: "" as any,
      bertugas_alamat: "",
      bertugas_negeri: "" as any,
      bertugas_poskod: "",
      no_telefon_pejabat: "",
      no_faks_pejabat: "",
      ketua_jabatan_emel: "",
      psm_emel: "",
      jenis_ahli_mia: "",
      no_ahli_mia: "",
      tarikh_ahli_mia: "",
      badan_ikhtisas: [
        {
          badan_ikhtisas: "",
          tarikh_lulus: "",
          tarikh_keahlian_penuh_lulus: "",
          no_keahlian: "",
        },
      ],
      penempatan_khas: { lokasi: "", poskod: "", negeri: "" },
      penempatan_khas_lokasi: "",
      penempatan_khas_negeri: "" as any,
      penempatan_khas_poskod: "",
      penempatan_pertama_negeri: "" as any,
      penempatan_pertama: "",
      penempatan_kedua_negeri: "" as any,
      penempatan_kedua: "",
      status_pinjaman_pendidikan: "",
      perakuan: {},
      data_medan_tambahan: {},
      kod_bangsa: "",
      kod_agama: "",
      bertugas_negeri_kod: "",
      pernah_pinjaman_pendidikan: "",
      keterangan_pinjaman_pendidikan: "",
      pinjaman_pendidikan_lampiran: null as any,
      pinjaman_pendidikan_lampiran_id: 0,
      sijilMIA: null as any,
      sijilBadanIkhtisas: null as any,
      skim_perkhidmatan_id: 0,
      nama_daerah: "",
      nama_sijil_badan_ikhtisas: "",
      psm_bahagian_id: 0,
      bertugas_bandar_kod: "" as any,
      // bangsa_id: null as number | null,
      status_perkahwinan_kod: "",
    });
    const lampiran = reactive({
      pinjaman_pendidikan_lampiran: null as any,
    });
    const sijils = reactive<{ [k in sijilType]: File | null }>({
      sijilMIA: null as any,
      sijilBadanIkhtisas: null as any,
    });
    const route = useRoute();
    const router = useRouter();
    let variables = reactive({
      id: 0,
      no_kad_pengenalan: "",
    });
    if (route.params.id != null) {
      variables.id = parseFloat(route.params.id.toString());
    } else {
      variables.id = 0;
    }
    let borang = ref({} as any);

    const handleSijilUpload = (event: Event, type: sijilType) => {
      const input = event.target as HTMLInputElement;

      if (!input.files?.length) return;

      const files = input.files[0];
      sijils[type] = files;

      console.log("Sijils", sijils.sijilMIA);
    };

    const handleFileUpload = async (event) => {
      const files = event.target.files[0];
      const name = event.target.name;
      lampiran[name] = files;
      console.log("Lampiran", lampiran.pinjaman_pendidikan_lampiran);
    };

    const uploadLampiran = async (file, type, oid) => {
      let formData = new FormData();
      formData.append("file", file);

      const t = await axios.post(
        process.env.VUE_APP_UPLOAD_URL + type + "/" + oid,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log("T-upload lampiran", t);
    };

    const {
      result: BorangList,
      refetch,
      load,
      onResult,
    } = useLazyQuery(naikPangkatBorangView, variables, {
      fetchPolicy: "network-only",
    });
    onResult((result) => {
      const list = result.data.naikPangkatBorangView;
      const clone = JSON.parse(JSON.stringify(list));
      clone.perakuan = typeof (clone.perakuan) == 'string' ? JSON.parse(clone.perakuan) : clone.perakuan;
      Object.assign(borang.value, clone);
      console.log("Borang", borang.value);
      form.naik_pangkat_id = clone.id;
      if (clone.kategori_permohonan == "PMK") {
        if (clone.jenis_permohonan != "IKHTISAS") {
          isPMK.value = true;
        }
      }
      form.status_permohonan = clone.status_permohonan;
    });

    const daerahList = ref<any[]>([]);
    const getDaerahList = async () => {
      try {
        const req2 = await apolloClient.query({
          query: listDaerah,
          fetchPolicy: "network-only",
        });

        const fetchedDaerahList = req2.data?.daerahList ?? [];
        
        if (!fetchedDaerahList.length) {
          console.warn('No daerah data found');
        } else {

          // Transform fetched data to include only specific attributes
          const transformedList = fetchedDaerahList.map((daerah) => ({
            kod_daerah: daerah.kod_daerah,
            nama_daerah: daerah.nama_daerah.toUpperCase(),
          }));

          // Push transformed data into daerahList
          daerahList.value.push(...transformedList);
        }
        
      } catch (error) {
        console.error('Error fetching daerah list:', error);
      }
    };

    // Computed property to filter daerah based on selected negeri for dropdown daerah
    const filteredDaerahList = computed(() => {
      console.log('filteredDaerahList trigerred', {negeri: form.bertugas_negeri, comboNegeri: combo.negeri, bandar: form.bertugas_bandar_kod});
      // Find the kod_negeri of the selected Negeri (from its id)
      const bertugasNegeri = form.bertugas_negeri + '';
      const selectedNegeri = combo.negeri.find(negeri => negeri.value === bertugasNegeri);
      
      // If a matching Negeri is found, filter daerahList by matching kod_negeri
      if (selectedNegeri) {
        return daerahList.value
          .filter(daerah => daerah.kod_daerah.substring(0, 2) === selectedNegeri.kod)
          .sort((a, b) => a.nama_daerah.localeCompare(b.nama_daerah));
      }
      
      // If no Negeri is selected, return an empty list
      return [];
    });

    // Computed property to find the corresponding nama_daerah for pengesahan maklumat
    const selectedDaerah = computed(() => {
      const selected = daerahList.value.find(
        (daerah) => daerah.kod_daerah === form.bertugas_bandar_kod
      );
      return selected ? selected.nama_daerah : "Tiada pilihan";
    });

    const counterNaikPangkatMohon = ref(0);
    const listPossibleStatusPermohonan = [
      'DRAF',
      'PERMOHONAN_MANUAL',
      'PERMOHONAN_OFFLINE',
    ];
    const { onResult: mohonResult, load: drafLoad, refetch: reloadDraft } = useLazyQuery(
      // naikPangkatMohonDrafCheck,
      naikPangkatMohonDrafCheck_V2,
      variablesMohon,
      {
        fetchPolicy: "no-cache",
      }
    );
    mohonResult((result) => {
      console.log('MOHON RESULT: ', result);
      if (result.loading == true) {
        return;
      }
      const list = result.data.naikPangkatMohonList;
      const mohon = JSON.parse(JSON.stringify(list));
      console.log("Mohon", mohon);
      if (mohon.length > 0) {
        form.id = mohon[0].id;
        form.emel = mohon[0].emel;
        form.ketua_jabatan_emel = mohon[0].emel_ketua_jabatan;
        form.psm_emel = mohon[0].naik_pangkat_pengesahan.emel_psm;
        form.jenis_ahli_mia = mohon[0].jenis_ahli_mia || null;
        form.no_ahli_mia = mohon[0].no_ahli_mia;
        form.tarikh_ahli_mia = mohon[0].tarikh_ahli_mia;
        form.tarikh_memangku = mohon[0].tarikh_memangku;
        form.jabatan_bertugas_semasa = mohon[0].jabatan_bertugas_semasa;
        form.badan_ikhtisas = mohon[0].badan_ikhtisas || [
          {
            badan_ikhtisas: "",
            tarikh_lulus: "",
            tarikh_keahlian_penuh_lulus: "",
            no_keahlian: "",
          },
        ];
        form.penempatan_khas_lokasi = mohon[0].penempatan_khas_lokasi;
        form.penempatan_khas_negeri = mohon[0].penempatan_khas_negeri_id;
        form.penempatan_khas_poskod = mohon[0].penempatan_khas_poskod;
        form.penempatan_khas.lokasi = mohon[0].penempatan_khas_lokasi;
        form.penempatan_khas.poskod = mohon[0].penempatan_khas_poskod;
        form.penempatan_khas.negeri = mohon[0].penempatan_khas_negeri;
        form.penempatan_pertama_negeri = mohon[0].penempatan_pertama_negeri_id;
        form.penempatan_pertama = mohon[0].penempatan_pertama;
        form.penempatan_kedua_negeri = mohon[0].penempatan_kedua_negeri_id;
        form.penempatan_kedua = mohon[0].penempatan_kedua;
        form.status_pinjaman_pendidikan = mohon[0].status_pinjaman_pendidikan;
        form.perakuan = mohon[0].perakuan;
        // form.perakuan = typeof(mohon[0].perakuan) == 'string' ? JSON.parse(mohon[0].perakuan) : mohon[0].perakuan;
        form.data_medan_tambahan = mohon[0].data_medan_tambahan;
        form.pernah_pinjaman_pendidikan =
          mohon[0].naik_pangkat_pengesahan?.pernah_pinjaman_pendidikan;
        form.keterangan_pinjaman_pendidikan =
          mohon[0].naik_pangkat_pengesahan?.keterangan_pinjaman_pendidikan;
        lampiran.pinjaman_pendidikan_lampiran =
          mohon[0].naik_pangkat_pengesahan?.pinjaman_pendidikan_lampiran_meta;
        form.pinjaman_pendidikan_lampiran =
          mohon[0].naik_pangkat_pengesahan?.pinjaman_pendidikan_lampiran_meta;
        sijils.sijilMIA = mohon[0].sijil_mia_lampiran_meta;
        form.sijilMIA = mohon[0].sijil_mia_lampiran_meta;
        sijils.sijilBadanIkhtisas = mohon[0].sijil_badan_ikhtisas_lampiran_meta;
        form.sijilBadanIkhtisas = mohon[0].sijil_badan_ikhtisas_lampiran_meta;
        form.nama_sijil_badan_ikhtisas = mohon[0].nama_sijil_badan_ikhtisas;
        form.psm_bahagian_id = mohon[0].naik_pangkat_pengesahan.psm_bahagian_id;

        setTimeout(() => {
          form.bertugas_negeri = mohon[0].bertugas_negeri_id;
          form.bertugas_bandar_kod = mohon[0].bertugas_bandar_kod;
        }, 100);

        form.status_permohonan = mohon[0].status_permohonan;
        if (isEditable.value) {
          form.bangsa = mohon[0].bangsa?.nama_bangsa || '';
          form.agama = mohon[0].agama?.nama_agama || '';
          form.alamat = mohon[0].tempat_tinggal_alamat || '';
          form.tempat_tinggal_negeri = mohon[0].tempat_tinggal_negeri?.nama_negeri || '';
          form.poskod = mohon[0].tempat_tinggal_poskod || '';
          form.status_perkahwinan = mohon[0].status_perkahwinan?.nama_sts_kahwin || '';
          form.jawatan_hakiki = mohon[0].jawatan || '';
          form.gred = mohon[0].gred || '';
          form.kementerian = mohon[0].kementerian?.nama_kementerian || '';
          form.bertugas_alamat = mohon[0].bertugas_alamat || '';
          form.bertugas_poskod = mohon[0].bertugas_poskod || '';
          form.no_telefon_pejabat = mohon[0].no_telefon_pejabat || '';
          form.no_faks_pejabat = mohon[0].no_faks_pejabat || '';
          form.tarikh_lantikan_sekarang = mohon[0].tarikh_lantikan_sekarang || '';
          form.tarikh_sah_sekarang = mohon[0].tarikh_sah_sekarang || '';
          form.tarikh_lahir = mohon[0].tarikh_lahir || '1950-01-01';
          form.umur = mohon[0].umur || '';
        };

      }
      else {
        var indexStatus = ++counterNaikPangkatMohon.value;
        if (indexStatus >= listPossibleStatusPermohonan.length) {
          return;
        }
        var status = listPossibleStatusPermohonan[indexStatus];
        console.log('RELOAD DRAFT NAIK PANGKAT MOHON WITH STATUS:', status);
        variablesMohon.status_permohonan = status;
        reloadDraft();
      }
    }); /** end of MohonResult() */


    // Enable HRMIS data fields for PERMOHONAN_MANUAL and PERMOHONAN_OFFLINE
    const isEditable = computed(() => ['PERMOHONAN_MANUAL', 'PERMOHONAN_OFFLINE'].includes(form.status_permohonan));

    const { result: comboResultNegeri, load: comboLoadNegeri } = useLazyQuery(
      comboNegeri,
      null,
      {
        fetchPolicy: "no-cache",
      }
    );
    comboLoadNegeri();
    watch(comboResultNegeri, (value) => {
      combo.negeri = value.negeriList
        .filter((k) => k.kod_negeri !== '00')
        .sort((a, b) => a.nama_negeri.localeCompare(b.nama_negeri))
        .map((k) => ({
          value: k.id,
          label: k.nama_negeri,
          kod: k.kod_negeri,
        }));
    });

    // Computed property to find the selected negeri
    const selectedNegeri = computed(() => {
      const selected = combo.negeri.find(
        (item) => item.value == form.bertugas_negeri
      );
      return selected ? selected.label : "Tiada Pilihan";
    });

    const { result: comboResult, load: comboLoad } = useLazyQuery(
      comboBorangPerkhidmatan,
      null,
      {
        fetchPolicy: "no-cache",
      }
    );
    comboLoad();
    watch(comboResult, (value) => {
      combo.kementerian = [];
      combo.jabatan = [];
      combo.agama = [];
      combo.bangsa = [];
      combo.status_perkahwinan = [];
      value.kementerianList.forEach((k) => {
        combo.kementerian.push({
          value: k.id,
          label: k.nama_kementerian
        });
      });
      value.jenisJabatanList.forEach((k) => {
        combo.jabatan.push({
          value: k.id,
          label: k.nama_jenis,
        });
      });
      value.bangsaList.forEach((k) => {
        combo.bangsa.push({
          value: k.id,              // 34
          label: k.nama_bangsa,     // Melayu
          kod: k.kod_bangsa,        // 01
        });
      });
      console.log("Combo Bangsa", combo.bangsa);
      value.agamaList.forEach((k) => {
        combo.agama.push({
          value: k.id,              // 2
          label: k.nama_agama,      // Islam
          kod: k.kod_agama,         // 01
        });
      });
      value.statusPerkahwinanList.forEach((k) => {
        combo.status_perkahwinan.push({
          value: k.id,                // 2
          label: k.nama_sts_kahwin,   // Belum Berkahwin
          kod: k.kod_sts_kahwin,      // 1
        });
      });
      console.log("Combo Status Perkahwinan", combo.status_perkahwinan);
    });

    const psmListEmpty = ref(false);
    const psmNotSelected = ref(false);
    const handlePsmListEmpty = (isEmpty: boolean) => {
      psmListEmpty.value = isEmpty;
    };
    const handlePsmNotSelected = (notSelected: boolean) => {
      psmNotSelected.value = notSelected;
    };

    onMounted(() => {
      load();
      form.nama = currentUser.nama_penuh;
      form.no_kad_pengenalan = currentUser.no_kad_pengenalan;
      form.pengguna_id = currentUser.id;
      form.no_telefon_bimbit = currentUser.no_telefon;
      // form.emel = currentUser.emel;
      form.jantina = currentUser.jantina;
      variablesMohon.pengguna_id = Number(currentUser.id);
      variablesMohon.naik_pangkat_id = Number(variables.id);
      _stepperObj.value = StepperComponent.createInsance(
        BorangPerkhidmatan.value as HTMLElement
      );
      variables.no_kad_pengenalan = currentUser.no_kad_pengenalan;
      profileLoad();
      if (route.name == "borang-urusan-draf") {
        drafLoad();
      }

      getDaerahList();
    });
    onBeforeUnmount(() => {
      _stepperObj.value = StepperComponent.createInsance(
        BorangPerkhidmatan.value as HTMLElement
      );
    });

    const ageCount = () => {
      const today = new Date();
      const birthDate = new Date(form.tarikh_lahir);
      const age = today.getFullYear() - birthDate.getFullYear();
      form.umur = age.toString();
    };

    watch(
      () => form.tarikh_lahir,
      () => {
        ageCount();
      }
    );

    watch(
      () => form.bangsa,
      (namaBangsa) => {
        const selected = combo.bangsa.find(b => b.label == namaBangsa);
        form.kod_bangsa = selected ? selected.kod : "";
      }
    );
    watch(
      () => form.agama,
      (namaAgama) => {
        const selected = combo.agama.find(a => a.label == namaAgama);
        form.kod_agama = selected ? selected.kod : "";
      }
    );
    watch(
      () => form.status_perkahwinan,
      (namaStatusPerkahwinan) => {
        const selected = combo.status_perkahwinan.find(a => a.label == namaStatusPerkahwinan);
        form.status_perkahwinan_kod = selected ? selected.kod : "";
      }
    );
    watch(
      () => form.bertugas_negeri,
      (negeri) => {
        const selected = combo.negeri.find(n => n.value == negeri);
        form.bertugas_negeri_kod = selected ? selected.kod : "";
      }
    );
    watch(
      () => form.bertugas_bandar_kod,
      (kodDaerah) => {
        const selected = daerahList.value.find(d => d.kod_daerah === kodDaerah);
        form.nama_daerah = selected ? selected.nama_daerah : "";
      }
    )

    const totalSteps = computed(() => {
      if (!_stepperObj.value) {
        return;
      }

      return _stepperObj.value.totatStepsNumber;
    });

    const previousStep = () => {
      if (!_stepperObj.value) {
        return;
      }
      currentStepIndex.value--;
      ElementAnimateUtil.scrollTop(0, 400);
      if (borang.value.jenis_permohonan != "IKHTISAS") {
        if (currentStepIndex.value == 2) {
          currentStepIndex.value = 1;
          _stepperObj.value._goTo(2);
        } else {
          _stepperObj.value.goPrev();
        }
      } else {
        _stepperObj.value.goPrev();
      }
    };

    const formValidation = [
      Yup.object({
        emel_ketua_jabatan: Yup.string()
          .email("E-mel Ketua Jabatan Tidak Sah")
          .required("E-mel Ketua Jabatan Wajib Diisi"),
        // emel_psm: Yup.string()
        //   .email("E-mel PSM Tidak Sah")
        //   .required("E-mel PSM Wajib Diisi"),
      }),
      Yup.object({
        keahlian_mia: Yup.string().required("Keahlian MIA Wajib Diisi"),
        no_ahli_mia: Yup.string().required("No MIA Wajib Diisi"),
        tarikh_ahli_mia: Yup.string().required(
          "Tarikh Keahlian MIA Wajib Diisi"
        ),
        sijil_mia: Yup.mixed().required("Sijil MIA Wajib Diisi"),

        badan_ikhtisas1: Yup.string().required("Badan Ikhtisas Wajib Diisi"),
        tarikh_lulus1: Yup.string().required("Tarikh Lulus Wajib Diisi"),
        tarikh_keahlian_penuh1: Yup.string().required(
          "Tarikh Keahlian Penuh Wajib Diisi"
        ),
        no_keahlian: Yup.string().required("No Keahlian Wajib Diisi"),
        sijil_ikhtisas: Yup.mixed().required("Sijil Ikhtisas Wajib Diisi"),
      }),
      Yup.object({
        penempatan_pertama: Yup.string().required("Lokasi Pertama Wajib Diisi"),
        penempatan_kedua: Yup.string().required("Lokasi Kedua Wajib Diisi"),
        penempatan_pertama_negeri: Yup.string().required(
          "Negeri Pertama Wajib Diisi"
        ),
        penempatan_kedua_negeri: Yup.string().required(
          "Negeri Kedua Wajib Diisi"
        ),
      }),
    ];

    const MAX_FILE_SIZE = 15728640;

    const handleStep = async (values) => {
      // form.jantina = jantina.value ? "Lelaki" : "Perempuan";
      let validation = false;
      // Validate for isEditable form
      if (isEditable.value) {
        if(currentStepIndex.value == 0) {
          if (form.tarikh_lahir == '1950-01-01') {
            SwalWarning({ title: 'Butir-Butir Diri', msg: 'Sila Kemaskini Tarikh Lahir' });
            return;
          }
          if (form.umur?.length == 0) {
            SwalWarning({ title: 'Butir-Butir Diri', msg: 'Umur tidak dibenarkan kosong' });
            return;
          }
          if (form.no_telefon_bimbit?.length == 0) {
            SwalWarning({ title: 'Butir-Butir Diri', msg: 'Nombor Telefon Bimbit tidak dibenarkan kosong' });
            return;
          }
          if (form.emel?.length == 0) {
            SwalWarning({ title: 'Butir-Butir Diri', msg: 'Emel tidak dibenarkan kosong' });
            return;
          }
          if (form.bangsa?.length == 0) {
            SwalWarning({ title: 'Butir-Butir Diri', msg: 'Bangsa tidak dibenarkan kosong' });
            return;
          }
          if (form.agama?.length == 0) {
            SwalWarning({ title: 'Butir-Butir Diri', msg: 'Agama tidak dibenarkan kosong' });
            return;
          }
          if (form.alamat?.length == 0) {
            SwalWarning({ title: 'Butir-Butir Diri', msg: 'Alamat Surat Menyurat tidak dibenarkan kosong' });
            return;
          }
          if (form.tempat_tinggal_negeri?.length == 0) {
            SwalWarning({ title: 'Butir-Butir Diri', msg: 'Negeri tidak dibenarkan kosong' });
            return;
          }
          if (form.poskod?.length == 0) {
            SwalWarning({ title: 'Butir-Butir Diri', msg: 'Poskod tidak dibenarkan kosong' });
            return;
          }
          if (form.status_perkahwinan?.length == 0) {
            SwalWarning({ title: 'Butir-Butir Diri', msg: 'Status Perkahwinan tidak dibenarkan kosong' });
            return;
          }
        }

        if (currentStepIndex.value == 1) {
          if (form.jawatan_hakiki?.length == 0) {
            SwalWarning({ title: 'Butir-Butir Perkhidmatan', msg: 'Jawatan Hakiki tidak dibenarkan kosong' });
            return;
          }
          if (form.gred?.length == 0) {
            SwalWarning({ title: 'Butir-Butir Perkhidmatan', msg: 'Gred tidak dibenarkan kosong' });
            return;
          }
          if (form.tarikh_lantikan_sekarang?.length == 0) {
            SwalWarning({ title: 'Butir-Butir Perkhidmatan', msg: 'Tarikh Lantikan Ke Perkhidmatan Sekarang tidak dibenarkan kosong' });
            return;
          }
          if (form.tarikh_sah_sekarang?.length == 0) {
            SwalWarning({ title: 'Butir-Butir Perkhidmatan', msg: 'Tarikh Sah ke Perkhidmatan tidak dibenarkan kosong' });
            return;
          }
          if (form.kementerian?.length == 0) {
            SwalWarning({ title: 'Butir-Butir Perkhidmatan', msg: 'Kementerian tidak dibenarkan kosong' });
            return;
          }
          if (form.bertugas_alamat?.length == 0) {
            SwalWarning({ title: 'Butir-Butir Perkhidmatan', msg: 'Alamat Tempat Kerja tidak dibenarkan kosong' });
            return;
          }
          if (form.bertugas_negeri?.length == 0) {
            SwalWarning({ title: 'Butir-Butir Perkhidmatan', msg: 'Negeri Pejabat tidak dibenarkan kosong' });
            return;
          }
          if (form.bertugas_poskod?.length == 0) {
            SwalWarning({ title: 'Butir-Butir Perkhidmatan', msg: 'Poskod tidak dibenarkan kosong' });
            return;
          }
        }
      };

      if (currentStepIndex.value == 1) {
        validation = await formValidation[currentStepIndex.value - 1].isValid({
          emel_ketua_jabatan: form.ketua_jabatan_emel,
          // emel_psm: form.psm_emel,
        });
        // console.log('borang PMKKNP :: handlestep :: form validation', [ form ]);

        // if (form.tarikh_memangku?.length == 0) {
        //   SwalWarning({ title: 'Butir-Butir Perkhidmatan', msg: 'Tarikh Memangku tidak dibenarkan kosong' });
        //   return;
        // }
        if (form.jabatan_bertugas_semasa?.length == 0) {
          SwalWarning({ title: 'Butir-Butir Perkhidmatan', msg: 'Jabatan Bertugas Semasa tidak dibenarkan kosong' });
          return;
        }
        if (form.nama_daerah?.length == 0) {
          SwalWarning({ title: 'Butir-Butir Perkhidmatan', msg: 'Daerah tidak dibenarkan kosong' });
          return;
        }
        if (form.bertugas_negeri?.length == 0) {
          SwalWarning({ title: 'Butir-Butir Perkhidmatan', msg: 'Negeri tidak dibenarkan kosong' });
          return;
        }

        if (!validation) {
          Swal.fire({
            text: "E-mel Ketua Jabatan tidak dibenarkan kosong / format E-mel tidak betul!",
            icon: "warning",
            showLoaderOnConfirm: true,
            buttonsStyling: false,
            confirmButtonText: "Ok",
            customClass: {
              confirmButton: "btn btn-primary",
            },
          });
          return;
        }
        validation = await formValidation[currentStepIndex.value - 1].isValid({
          pernah_pinjaman_pendidikan: form.pernah_pinjaman_pendidikan,
          ...(form.pernah_pinjaman_pendidikan != "Tiada" && {
            keterangan_pinjaman_pendidikan: form.keterangan_pinjaman_pendidikan,
          }),
          ...(form.pernah_pinjaman_pendidikan != "Tiada" && {
            lampiran_pinjam_pendidikan: form.pinjaman_pendidikan_lampiran,
          }),
        });

        if(form.psm_bahagian_id <= 0){
          SwalWarning({title:'Butir-Butir Pegawai PSM Jabatan', msg: 'Sila Pilih Pegawai PSM'});
          return;
        }

        if (psmListEmpty.value) {
          SwalWarning({title:'Butir-Butir Pegawai PSM Jabatan', msg: 'PSM tiada dalam senarai, sila hubungi talian meja bantuan bagi penambahan PSM'});
          return
        }

        if (psmNotSelected.value) {
          SwalWarning({title:'Butir-Butir Pegawai PSM Jabatan', msg: 'Sila Pilih Pegawai PSM'});
          return
        }

        if (['IKHTISAS', 'PMK_WA41_WA44', 'PMK_WA44_WA48', 'PMK_WA48_WA52', 'PMK_WA52_WA54'].includes(borang.value?.jenisPermohonan?.kod?.toUpperCase())) {
            if (sijils.sijilBadanIkhtisas) {
                const file = sijils.sijilBadanIkhtisas;

                // Check if the file name ends with .pdf (case-insensitive)
                if (!file.name.toLowerCase().endsWith('.pdf')) {
                    SwalWarning({
                        title: 'Butir-Butir Sijil Badan Ikhtisas',
                        msg: 'Format lampiran Sijil Badan Ikhtisas yang diterima adalah PDF sahaja'
                    });
                    return;
                }
            } else if (!form.sijilBadanIkhtisas) {
                SwalWarning({
                    title: 'Butir-Butir Sijil Badan Ikhtisas',
                    msg: 'Sila muatnaik lampiran Sijil Badan Ikhtisas'
                });
                return;
            }
        }

        if (
          form.pernah_pinjaman_pendidikan == "" ||
          (form.pernah_pinjaman_pendidikan != "Tiada" &&
            (form.keterangan_pinjaman_pendidikan == "" ||
              lampiran.pinjaman_pendidikan_lampiran == null))
        ) {
          Swal.fire({
            text: "Medan Pinjaman Pendidikan tidak dibenarkan kosong",
            icon: "warning",
            showLoaderOnConfirm: true,
            buttonsStyling: false,
            confirmButtonText: "Ok",
            customClass: {
              confirmButton: "btn btn-primary",
            },
          });
          return;
        } else if (
          lampiran.pinjaman_pendidikan_lampiran?.nama_asal == null &&
          lampiran.pinjaman_pendidikan_lampiran?.name != null &&
          ![
            ".pdf",
            ".PDF",
            ".doc",
            ".docx"
          ].includes(
            lampiran.pinjaman_pendidikan_lampiran?.name.slice(
              ((lampiran.pinjaman_pendidikan_lampiran?.name.lastIndexOf(".") -
                2) >>>
                0) +
              2
            )
          )
        ) {
          Swal.fire({
            text: "Jenis dokumen pinjaman pendidikan tidak betul. Sila muat naik semula.",
            icon: "warning",
            buttonsStyling: false,
            confirmButtonText: "Ok",
            customClass: {
              confirmButton: "btn btn-primary",
            },
          });
          return true;
        } else if (
          variablesMohon.status_permohonan == "DRAF" &&
          lampiran.pinjaman_pendidikan_lampiran?.nama_asal != null &&
          ![
            ".pdf",
            ".PDF",
            ".doc",
            ".docx"
          ].includes(
            lampiran.pinjaman_pendidikan_lampiran?.nama_asal.slice(
              ((lampiran.pinjaman_pendidikan_lampiran?.nama_asal.lastIndexOf(
                "."
              ) -
                2) >>>
                0) +
              2
            )
          )
        ) {
          Swal.fire({
            text: "Jenis dokumen pinjaman pendidikan tidak betul. Sila muat naik semula.",
            icon: "warning",
            buttonsStyling: false,
            confirmButtonText: "Ok",
            customClass: {
              confirmButton: "btn btn-primary",
            },
          });
          return true;
        } else if (
          lampiran.pinjaman_pendidikan_lampiran?.name != null &&
          lampiran.pinjaman_pendidikan_lampiran?.size >= MAX_FILE_SIZE
        ) {
          Swal.fire({
            text: "Lampiran Pinjaman Pendidikan saiz tidak boleh lebih daripada 15MB. Sila muat naik semula.",
            icon: "warning",
            buttonsStyling: false,
            confirmButtonText: "Ok",
            customClass: {
              confirmButton: "btn btn-primary",
            },
          });
          return true;
        }
      } else if (
        borang.value.jenis_permohonan == "IKHTISAS" &&
        currentStepIndex.value == 2
      ) {
        validation = await validateBadanIkhtisasForm();
        if (!validation) {
          Swal.fire({
            text: "Ruangan wajib tidak dibenarkan kosong",
            icon: "warning",
            showLoaderOnConfirm: true,
            buttonsStyling: false,
            confirmButtonText: "Ok",
            customClass: {
              confirmButton: "btn btn-primary",
            },
          });
          return false;
        } else if (
          form.sijilMIA?.nama_asal == null &&
          sijils.sijilMIA != null &&
          ![
            ".pdf",
            ".PDF",
            ".doc",
            ".docx"
          ].includes(
            sijils.sijilMIA?.name.slice(
              ((sijils.sijilMIA?.name.lastIndexOf(".") - 2) >>> 0) + 2
            )
          )
        ) {
          Swal.fire({
            text: "Jenis dokumen sijils MIA tidak betul. Sila muat naik semula.",
            icon: "warning",
            buttonsStyling: false,
            confirmButtonText: "Ok",
            customClass: {
              confirmButton: "btn btn-primary",
            },
          });
          return true;
        }
        if (
          variablesMohon.status_permohonan == "DRAF" &&
          form.sijilMIA?.nama_asal != null &&
          sijils.sijilMIA?.name != null &&
          ![
            ".pdf",
            ".PDF",
            ".doc",
            ".docx"
          ].includes(
            sijils.sijilMIA?.name.slice(
              ((sijils.sijilMIA?.name.lastIndexOf(".") - 2) >>> 0) + 2
            )
          )
        ) {
          Swal.fire({
            text: "Jenis dokumen sijils MIA tidak betul. Sila muat naik semula.",
            icon: "warning",
            buttonsStyling: false,
            confirmButtonText: "Ok",
            customClass: {
              confirmButton: "btn btn-primary",
            },
          });
          return true;
        } else if (
          sijils.sijilMIA?.name != null &&
          sijils.sijilMIA?.size >= MAX_FILE_SIZE
        ) {
          Swal.fire({
            text: "Lampiran Sijil MIA saiz tidak boleh lebih daripada 15MB. Sila muat naik semula.",
            icon: "warning",
            buttonsStyling: false,
            confirmButtonText: "Ok",
            customClass: {
              confirmButton: "btn btn-primary",
            },
          });
          return true;
        } else if (
          form.sijilBadanIkhtisas?.nama_asal == null &&
          sijils.sijilBadanIkhtisas != null &&
          ![
            ".pdf",
            ".PDF",
            ".doc",
            ".docx"
          ].includes(
            sijils.sijilBadanIkhtisas?.name.slice(
              ((sijils.sijilBadanIkhtisas?.name.lastIndexOf(".") - 2) >>> 0) + 2
            )
          )
        ) {
          Swal.fire({
            text: "Jenis dokumen sijils badan ikhtisas tidak betul. Sila muat naik semula.",
            icon: "warning",
            buttonsStyling: false,
            confirmButtonText: "Ok",
            customClass: {
              confirmButton: "btn btn-primary",
            },
          });
          return true;
        } else if (
          variablesMohon.status_permohonan == "DRAF" &&
          form.sijilBadanIkhtisas?.nama_asal != null &&
          sijils.sijilBadanIkhtisas?.name != null &&
          ![
            ".pdf",
            ".PDF",
            ".doc",
            ".docx"
          ].includes(
            sijils.sijilBadanIkhtisas?.name.slice(
              ((sijils.sijilBadanIkhtisas?.name.lastIndexOf(".") - 2) >>> 0) + 2
            )
          )
        ) {
          Swal.fire({
            text: "Jenis dokumen sijils badan ikhtisas tidak betul. Sila muat naik semula.",
            icon: "warning",
            buttonsStyling: false,
            confirmButtonText: "Ok",
            customClass: {
              confirmButton: "btn btn-primary",
            },
          });
          return true;
        } else if (
          sijils.sijilBadanIkhtisas?.name != null &&
          sijils.sijilBadanIkhtisas?.size >= MAX_FILE_SIZE
        ) {
          Swal.fire({
            text: "Lampiran Sijil Badan Ikhtisas saiz tidak boleh lebih daripada 15MB. Sila muat naik semula.",
            icon: "warning",
            buttonsStyling: false,
            confirmButtonText: "Ok",
            customClass: {
              confirmButton: "btn btn-primary",
            },
          });
          return true;
        }
      }
      currentStepIndex.value++;
      ElementAnimateUtil.scrollTop(0, 600);
      if (!_stepperObj.value) {
        return;
      }
      if (borang.value.jenis_permohonan != "IKHTISAS") {
        if (currentStepIndex.value == 2) {
          currentStepIndex.value = 3;
          _stepperObj.value._goTo(4);
        } else {
          _stepperObj.value.goNext();
        }
      } else {
        _stepperObj.value.goNext();
      }
    };

    watch(
      () => borang.value.jenis_permohonan,
      () => {
        if (borang.value.jenis_permohonan) {
          if (borang.value.jenis_permohonan == "IKHTISAS") {
            form.tarikh_ahli_mia = moment().format("YYYY-MM-DD");
            form.badan_ikhtisas[0].tarikh_lulus = moment().format("YYYY-MM-DD");
            form.badan_ikhtisas[0].tarikh_keahlian_penuh_lulus =
              moment().format("YYYY-MM-DD");
          }
        }
      }
    );

    const validateBadanIkhtisasForm = async () => {
      return await formValidation[currentStepIndex.value - 1].isValid({
        keahlian_mia: form.jenis_ahli_mia,
        no_ahli_mia: form.no_ahli_mia,
        tarikh_ahli_mia: form.tarikh_ahli_mia,
        sijil_mia: sijils.sijilMIA,
        badan_ikhtisas1: form.badan_ikhtisas[0].badan_ikhtisas,
        tarikh_lulus1: form.badan_ikhtisas[0].tarikh_lulus,
        tarikh_keahlian_penuh1:
          form.badan_ikhtisas[0].tarikh_keahlian_penuh_lulus,
        no_keahlian: form.badan_ikhtisas[0].no_keahlian,
        sijil_ikhtisas: sijils.sijilBadanIkhtisas,
      });
    };

    const validatePenempatan = async () => {
      return await formValidation[currentStepIndex.value - 1].isValid({
        penempatan_pertama: form.penempatan_pertama,
        penempatan_kedua: form.penempatan_kedua,
        penempatan_pertama_negeri: form.penempatan_pertama_negeri,
        penempatan_kedua_negeri: form.penempatan_kedua_negeri,
      });
    };

    let permohonan = {} as any;
    const {
      mutate: NaikPangkatMohonCreate,
      onDone: NaikPangkatMohonDone,
      onError: NaikPangkatMohonError,
    } = useMutation(naikPangkatMohonCreate, () => ({
      variables: permohonan,
    }));

    NaikPangkatMohonDone(() => {
      Swal.fire({
        text: `Borang Permohonan Berjaya ${form.status_permohonan == "DRAF" ? "Disimpan" : "Dihantar"
          }`,
        icon: "success",
        buttonsStyling: false,
        confirmButtonText: "Ok",
        customClass: {
          confirmButton: "btn btn-primary",
        },
      }).then(() => {
        router.push({ name: "status-kenaikan-pangkat" });
      });
    });
    NaikPangkatMohonError((err) => {
      Swal.fire({
        text: err.message,
        icon: "error",
        buttonsStyling: false,
        confirmButtonText: "Ok",
        customClass: {
          confirmButton: "btn btn-primary",
        },
      });
    });

    const {
      mutate: NaikPangkatMohonUpdate,
      onDone: NaikPangkatMohonUpdateDone,
      onError: NaikPangkatMohonUpdateError,
    } = useMutation(naikPangkatMohonUpdate, () => ({
      variables: {
        id: Number(form.id),
        ...permohonan,
        psm_bahagian_id: form.psm_bahagian_id,
      },
    }));

    NaikPangkatMohonUpdateDone(() => {
      Swal.fire({
        text: `Borang Permohonan Berjaya ${form.status_permohonan == "DRAF" ? "Disimpan" : "Dihantar"
          }`,
        icon: "success",
        buttonsStyling: false,
        confirmButtonText: "Ok",
        customClass: {
          confirmButton: "btn btn-primary",
        },
      }).then(() => {
        router.push({ name: "status-kenaikan-pangkat" });
      });
    });
    NaikPangkatMohonUpdateError((err) => {
      Swal.fire({
        text: err.message,
        icon: "error",
        buttonsStyling: false,
        confirmButtonText: "Ok",
        customClass: {
          confirmButton: "btn btn-primary",
        },
      });
    });

    const formSubmit = async (status) => {
      if (
        borang.value.kategori_permohonan == "PMK" &&
        borang.value.jenis_permohonan != "IKHTISAS" &&
        borang.value.penempatan_khas == 0 &&
        (form.penempatan_pertama_negeri == null ||
          form.penempatan_pertama_negeri == "" ||
          form.penempatan_pertama == "" ||
          form.penempatan_pertama == null)
      ) {
        Swal.fire({
          text: "Pilihan Penempatan Pertama tidak dibenarkan kosong",
          icon: "warning",
          showLoaderOnConfirm: true,
          buttonsStyling: false,
          confirmButtonText: "Ok",
          customClass: {
            confirmButton: "btn btn-primary",
          },
        });
        return false;
      }
      if (
        borang.value.kategori_permohonan == "PMK" &&
        borang.value.jenis_permohonan != "IKHTISAS" &&
        borang.value.penempatan_khas == 0 &&
        (form.penempatan_kedua_negeri == null ||
          form.penempatan_kedua_negeri == "" ||
          form.penempatan_kedua == null ||
          form.penempatan_kedua == "")
      ) {
        Swal.fire({
          text: "Pilihan Penempatan Kedua tidak dibenarkan kosong",
          icon: "warning",
          showLoaderOnConfirm: true,
          buttonsStyling: false,
          confirmButtonText: "Ok",
          customClass: {
            confirmButton: "btn btn-primary",
          },
        });
        return false;
      }

      if (
        borang.value.kategori_permohonan == "PMK" &&
        borang.value.penempatan_khas == 1 &&
        (form.penempatan_khas_lokasi == null ||
          form.penempatan_khas_lokasi == "" ||
          form.penempatan_khas_poskod == null ||
          form.penempatan_khas_poskod == "" ||
          form.penempatan_khas_negeri == null ||
          form.penempatan_khas_negeri == "")
      ) {
        Swal.fire({
          text: "Penempatan Khas tidak dibenarkan kosong",
          icon: "warning",
          showLoaderOnConfirm: true,
          buttonsStyling: false,
          confirmButtonText: "Ok",
          customClass: {
            confirmButton: "btn btn-primary",
          },
        });
        return false;
      }

      if (
        (form.status_permohonan === "PERMOHONAN_MANUAL" || form.status_permohonan === "PERMOHONAN_OFFLINE") && status === "DRAF")
      {
        // Skip updating to DRAF to preserve editable status
      } else {
        form.status_permohonan = status;
      }

      // form.status_permohonan = status;
      const checked = checkedPengakuan.value.filter((x) => x == true);
      console.log("Form", form);

      if (borang.value.perakuan?.length != checked.length && status != "DRAF") {
        Swal.fire({
          text: "Sila Klik dan Sah pada Pengakuan Permohonan!",
          icon: "warning",
          buttonsStyling: false,
          confirmButtonText: "Ok",
          customClass: {
            confirmButton: "btn btn-primary",
          },
        }).then(() => {
          currentStepIndex.value = totalSteps.value - 1;
        });
        return;
      }

      if(form.psm_bahagian_id <= 0) {
        SwalError({title: 'Kesalahan', msg: 'Sila pilih Pegawai PSM'});
        return;
      }

      Swal.fire({
        title: "Sahkan penghantaran/penyimpanan borang?",
        showCancelButton: true,
        confirmButtonText: "YA",
        denyButtonText: `Tidak`,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-danger",
        },
      }).then((result) => {
        if (result.dismiss == "cancel") {
          currentStepIndex.value = totalSteps.value - 1;
        } else {
          if (borang.value.jenis_permohonan == "IKHTISAS") {
            permohonan = {
              naik_pangkat_id: Number(form.naik_pangkat_id),
              pengguna_id: Number(form.pengguna_id),
              tarik_memangku: form.tarikh_memangku ? moment(form.tarikh_memangku).format('YYYY-MM-DD') : null,
              jabatan_bertugas_semasa: form.jabatan_bertugas_semasa,
              tarikh_masa_hantar: form.tarikh_masa_hantar || null,
              status_permohonan: form.status_permohonan,
              nama: form.nama,
              no_kad_pengenalan: form.no_kad_pengenalan.replace(/\D/g, ""),
              tarikh_lahir: form.tarikh_lahir || null,
              umur: Number(form.umur),
              bangsa_id: Number(form.bangsa),
              agama_id: Number(form.agama),
              emel: form.emel,
              no_telefon_bimbit: form.no_telefon_bimbit,
              tempat_tinggal_alamat: form.alamat,
              tempat_tinggal_poskod: form.poskod,
              tempat_tinggal_negeri_id: Number(
                combo.negeri
                  .find(
                    (x) =>
                      x.label.toUpperCase() ==
                      form.tempat_tinggal_negeri.toUpperCase()
                  )
                  ?.value.toString() ?? ""
              ),
              tempat_tinggal_negeri_kod:
                combo.negeri
                  .find(
                    (x) =>
                      x.label.toUpperCase() ==
                      form.tempat_tinggal_negeri.toUpperCase()
                  )
                  ?.kod.toString() ?? "",
              status_perkahwinan_kod: form.status_perkahwinan?.kod_perkahwinan,
              skim_perkhidmatan_id: Number(form.skim_perkhidmatan_id),
              gred: form.gred,
              tarikh_lantikan_sekarang: form.tarikh_lantikan_sekarang || null,
              tarikh_sah_sekarang: form.tarikh_sah_sekarang || null,
              tarikh_naik_pangkat_terakhir: form.tarikh_naik_pangkat_terakhir || null,
              tarikh_memangku: form.tarikh_memangku ? moment(form.tarikh_memangku).format('YYYY-MM-DD') : null,
              tarikh_persaraan: form.tarikh_persaraan || null,
              kementerian_id: Number(
                combo.kementerian
                  .find(
                    (x) =>
                      x.label.toUpperCase() == form.kementerian.toUpperCase()
                  )
                  ?.value.toString() ??
                form.kementerianObj.id ??
                ""
              ),
              agensi_id: Number(form.agensi?.id ?? form.agensiObj.id),
              bertugas_alamat: form.bertugas_alamat,
              bertugas_poskod: form.bertugas_poskod,
              bertugas_negeri_id: Number(form.bertugas_negeri),
              no_telefon_pejabat: form.no_telefon_pejabat,
              no_faks_pejabat: form.no_faks_pejabat,
              emel_ketua_jabatan: form.ketua_jabatan_emel,
              emel_psm: form.psm_emel,
              jenis_ahli_mia: form.jenis_ahli_mia,
              no_ahli_mia: form.no_ahli_mia,
              tarikh_ahli_mia: moment(form.tarikh_ahli_mia).format("YYYY-MM-DD") || null,
              badan_ikhtisas: form.badan_ikhtisas || null,
              penempatan_khas_lokasi: form.penempatan_khas_lokasi || null,
              penempatan_khas_negeri_id: Number(form.penempatan_khas_negeri) || null,
              penempatan_khas_poskod: form.penempatan_khas_poskod || null,
              penempatan_pertama_negeri_id: Number(form.penempatan_pertama_negeri) || null,
              penempatan_kedua_negeri_id: Number(form.penempatan_kedua_negeri) || null,
              penempatan_pertama: form.penempatan_pertama || null,
              penempatan_kedua: form.penempatan_kedua || null,
              status_pinjaman_pendidikan: form.status_pinjaman_pendidikan,
              perakuan: form.perakuan,
              data_medan_tambahan: form.data_medan_tambahan,
              jawatan: form.jawatan_hakiki,
              kod_bangsa: form.kod_bangsa,
              kod_agama: form.kod_agama,
              bertugas_negeri_kod: form.bertugas_negeri_kod,
              nama_sijil_badan_ikhtisas: form.nama_sijil_badan_ikhtisas,
              pernah_pinjaman_pendidikan: form.pernah_pinjaman_pendidikan,
              keterangan_pinjaman_pendidikan:
                form.pernah_pinjaman_pendidikan != "Tiada"
                  ? form.keterangan_pinjaman_pendidikan
                  : "",
              ...(form.pernah_pinjaman_pendidikan == "Tiada" && {
                pinjaman_pendidikan_lampiran_id: 0,
              }),
              psm_bahagian_id: form.psm_bahagian_id,
              bertugas_bandar_kod: form.bertugas_bandar_kod,
            };
          } else {
            permohonan = {
              naik_pangkat_id: Number(form.naik_pangkat_id),
              pengguna_id: Number(form.pengguna_id),
              tarik_memangku: form.tarikh_memangku ? moment(form.tarikh_memangku).format('YYYY-MM-DD') : null,
              jabatan_bertugas_semasa: form.jabatan_bertugas_semasa,
              tarikh_masa_hantar: form.tarikh_masa_hantar || null,
              status_permohonan: form.status_permohonan,
              nama: form.nama,
              no_kad_pengenalan: form.no_kad_pengenalan.replace(/\D/g, ""),
              tarikh_lahir: form.tarikh_lahir ? moment(form.tarikh_lahir).format('YYYY-MM-DD') : null,
              umur: Number(form.umur),
              bangsa_id: Number(form.bangsa?.id),
              agama_id: Number(form.agama?.id),
              emel: form.emel,
              no_telefon_bimbit: form.no_telefon_bimbit,
              tempat_tinggal_alamat: form.alamat,
              tempat_tinggal_poskod: form.poskod,
              tempat_tinggal_negeri_id: Number(
                combo.negeri
                  .find(
                    (x) =>
                      x.label.toUpperCase() ==
                      form.tempat_tinggal_negeri.toUpperCase()
                  )
                  ?.value.toString() ?? ""
              ),
              tempat_tinggal_negeri_kod:
                combo.negeri
                  .find(
                    (x) =>
                      x.label.toUpperCase() ==
                      form.tempat_tinggal_negeri.toUpperCase()
                  )
                  ?.kod.toString() ?? "",
              // status_perkahwinan_kod: form.status_perkahwinan?.kod_perkahwinan,
              status_perkahwinan: form.status_perkahwinan_kod,
              skim_perkhidmatan_id: Number(form.skim_perkhidmatan_id),
              gred: form.gred,
              tarikh_lantikan_sekarang: form.tarikh_lantikan_sekarang ? moment(form.tarikh_lantikan_sekarang).format('YYYY-MM-DD') : null,
              tarikh_sah_sekarang: form.tarikh_sah_sekarang ? moment(form.tarikh_sah_sekarang).format('YYYY-MM-DD') : null,
              tarikh_naik_pangkat_terakhir:
                form.tarikh_naik_pangkat_terakhir || null,
              tarikh_memangku: form.tarikh_memangku ? moment(form.tarikh_memangku).format('YYYY-MM-DD') : null,
              tarikh_persaraan: form.tarikh_persaraan || null,
              kementerian_id: Number(
                combo.kementerian
                  .find(
                    (x) =>
                      x.label.toUpperCase() == form.kementerian.toUpperCase()
                  )
                  ?.value.toString() ??
                form.kementerianObj.id ??
                ""
              ),
              agensi_id: Number(form.agensi?.id ?? form.agensiObj.id),
              bertugas_alamat: form.bertugas_alamat,
              bertugas_poskod: form.bertugas_poskod,
              bertugas_negeri_id: Number(form.bertugas_negeri),
              no_telefon_pejabat: form.no_telefon_pejabat,
              no_faks_pejabat: form.no_faks_pejabat,
              emel_ketua_jabatan: form.ketua_jabatan_emel,
              emel_psm: form.psm_emel,
              penempatan_khas_lokasi: form.penempatan_khas_lokasi || null,
              penempatan_khas_negeri_id:
                Number(form.penempatan_khas_negeri) || null,
              penempatan_khas_poskod: form.penempatan_khas_poskod || null,
              penempatan_pertama_negeri_id:
                Number(form.penempatan_pertama_negeri) || null,
              penempatan_kedua_negeri_id:
                Number(form.penempatan_kedua_negeri) || null,
              penempatan_pertama: form.penempatan_pertama || null,
              penempatan_kedua: form.penempatan_kedua || null,
              status_pinjaman_pendidikan: form.status_pinjaman_pendidikan,
              perakuan: form.perakuan,
              data_medan_tambahan: form.data_medan_tambahan,
              jawatan: form.jawatan_hakiki,
              kod_bangsa: form.kod_bangsa,
              kod_agama: form.kod_agama,
              bertugas_negeri_kod: form.bertugas_negeri_kod,
              nama_sijil_badan_ikhtisas: form.nama_sijil_badan_ikhtisas,
              pernah_pinjaman_pendidikan: form.pernah_pinjaman_pendidikan,
              keterangan_pinjaman_pendidikan:
                form.pernah_pinjaman_pendidikan != "Tiada"
                  ? form.keterangan_pinjaman_pendidikan
                  : "",
              ...(form.pernah_pinjaman_pendidikan == "Tiada" && {
                pinjaman_pendidikan_lampiran_id: 0,
              }),
              psm_bahagian_id: form.psm_bahagian_id,
              bertugas_bandar_kod: form.bertugas_bandar_kod,
            };
            console.log("Permohonan Data", permohonan);
          }
          if (route.name == "borang-urusan")
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            NaikPangkatMohonCreate().then((result: any) => {
              if (form.pernah_pinjaman_pendidikan != "Tiada") {
                ref(
                  uploadLampiran(
                    lampiran.pinjaman_pendidikan_lampiran,
                    "pinjaman_pendidikan_lampiran_id",
                    result.data.naikPangkatMohonCreate.oid
                  )
                );
              }

              if (sijils.sijilBadanIkhtisas != null) {
                ref(
                  uploadLampiran(
                    sijils.sijilBadanIkhtisas,
                    "lampiran_Sijil_Badan_Ikhtisas",
                    result.data.naikPangkatMohonCreate.oid2
                  )
                );
              }
              if (sijils.sijilMIA != null) {
                ref(
                  uploadLampiran(
                    sijils.sijilMIA,
                    "lampiran_Sijil_MIA",
                    result.data.naikPangkatMohonCreate.oid2
                  )
                );
              }

              router.push({ name: "status-kenaikan-pangkat" });
            });
          else {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            NaikPangkatMohonUpdate().then((result: any) => {
              console.log("Update", result);
              if (form.pernah_pinjaman_pendidikan != "Tiada") {
                ref(
                  uploadLampiran(
                    lampiran.pinjaman_pendidikan_lampiran,
                    "pinjaman_pendidikan_lampiran_id",
                    result.data.naikPangkatMohonUpdate.oid
                  )
                );
              }

              ref(
                uploadLampiran(
                  sijils.sijilBadanIkhtisas,
                  "lampiran_Sijil_Badan_Ikhtisas",
                  result.data.naikPangkatMohonUpdate.oid2
                )
              );

              ref(
                uploadLampiran(
                  sijils.sijilMIA,
                  "lampiran_Sijil_MIA",
                  result.data.naikPangkatMohonUpdate.oid2
                )
              );
            });
          }
        }
      });
      // }
    };

    // Auto populate form
    const {
      result: profileResult,
      load: profileLoad,
      onError: profileError,
    } = useLazyQuery(penggunaProfilHRMIS, variables, {
      fetchPolicy: "no-cache",
    });

    profileError(() => {
      router.push({ path: "/" });
    });

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const getLokasiPenempatanKhas = (item: any) => {
      console.log("Item", item);
      form.penempatan_khas_lokasi = item.lokasi;
      form.penempatan_khas_poskod = item.poskod;
      form.penempatan_khas_negeri = item.negeri;
    };

    watch(profileResult, (value) => {
      const profile = value.penggunaProfilHRMIS;
      console.log("Profile", profile);
      if (profile) {
        form.no_kad_pengenalan = variables.no_kad_pengenalan;
        form.nama = profile.nama_penuh;
        form.tarikh_lahir = profile.tarikh_lahir;
        ageCount();
        form.jantina =
          profile.jantina == "P"
            ? "Perempuan"
            : "" || profile.jantina == "L"
              ? "Lelaki"
              : "";
        form.emel = profile.emel;
        form.no_telefon_bimbit = profile.no_telefon_bimbit;
        form.bangsa = profile.bangsa?.nama_bangsa || "";
        form.agama = profile.agama?.nama_agama || "";
        form.alamat = profile.tempat_tinggal_alamat;
        form.poskod = profile.tempat_tinggal_poskod;
        form.tempat_tinggal_negeri = profile.tempat_tinggal_negeri?.nama_negeri;
        form.status_perkahwinan = profile.status_perkahwinan?.nama_sts_kahwin;

        // Butir-Butir Perkhidmatan
        form.jawatan_hakiki = profile.jawatan;
        form.gred = profile.gred_terkini;
        form.gaji_pokok = profile.gaji_pokok || 0;
        form.tarikh_lantikan_sekarang = profile.tarikh_lantikan_jawatan;
        form.tarikh_sah_sekarang = profile.tarikh_lantikan_jawatan_sah;
        form.tarikh_naik_pangkat_terakhir =
          profile.tarikh_naik_pangkat_terakhir;
        // form.tarikh_memangku = profile.tarikh_pemangkuan;
        form.tarikh_persaraan = profile.tarikh_bersara;
        form.kementerian = profile.kementerian_name;
        if (profile.kementerian) {
          form.kementerianObj.id = profile.kementerian.id;
          form.kementerianObj.nama_kementerian =
            profile.kementerian.nama_kementerian;
        }
        if (profile.agensi) {
          form.agensiObj.id = profile.agensi.id;
          form.agensiObj.nama_agensi = profile.agensi.nama_agensi;
        }

        form.bertugas_alamat = profile.bertugas_alamat;
        // form.bertugas_negeri = profile.bertugas_negeri?.nama_negeri;
        form.bertugas_poskod = profile.bertugas_poskod;
        form.no_telefon_pejabat = profile.no_telefon_pejabat;
        form.no_faks_pejabat = profile.no_faks_pejabat;
        form.skim_perkhidmatan_id = profile.skim_perkhidmatan
          ? profile.skim_perkhidmatan.id
          : profile.kod_perkhidmatan_skim
            ? profile.kod_perkhidmatan_skim.id
            : 0;

        // Handle kod
        form.kod_agama = profile.kod_agama;
        form.kod_bangsa = profile.kod_bangsa;
        form.bertugas_negeri_kod = profile.bertugas_negeri_kod;
        form.nama_daerah = profile.bertugas_bandar?.nama_daerah;

        console.log('PROFILE: ', { profile });
      }
    });

    const strToBase64 = (payload) => {
      return btoa(unescape(encodeURIComponent(payload)));
    };

    // Handle block checking
    const {
      onResult: naikPangkatMohonCheckOnResult,
      onError: naikPangkatMohonCheckOnError,
    } = useQuery(
      naikPangkatMohonCheck,
      { borang_id: Number(route.params.id) },
      {
        fetchPolicy: "network-only",
      }
    );

    onBeforeMount(() => {
      naikPangkatMohonCheckOnResult(() => {
        is_allowed.value = true;
      });
      naikPangkatMohonCheckOnError((err) => {
        const message = JSON.parse(err.message);
        if (message?.code == 100 && route.name == "borang-urusan-draf") {
          is_allowed.value = true;
          return;
        }

        router.push({
          name: "perkhidmatan-blocked",
          params: { data: strToBase64(err.message) },
        });
      });
    });

    const searchDaerah1 = ref("");
    const selectedDaerah1 = ref(null);
    const {
      result: daerahResult1,
      loading: daerahLoading1,
      load: executeDaerahQuery1,
      error: daerahError1,
    } = useLazyQuery(listDaerah);

    watch(daerahResult1, (newResult) => {
      if (newResult && newResult.data && newResult.data.daerahList) {
        console.log("Daerah Result 1:", newResult.data.daerahList);
      } else {
        console.warn("No Daerah List available for Daerah 1");
      }
    });

    // const filteredDaerah1 = computed(() => {
    //   if (!daerahResult1.value || !daerahResult1.value.daerahList) return [];
    //   return daerahResult1.value.daerahList.filter((daerah) =>
    //     daerah.nama_daerah
    //       ?.toLowerCase()
    //       .includes(searchDaerah1.value.toLowerCase())
    //   );
    // });
    const filteredDaerah1 = computed(() => {
      if (!daerahResult1.value || !daerahResult1.value.daerahList) return [];

      const negeriId = form.penempatan_pertama_negeri + '';
      const selectedNegeri1 = combo.negeri.find((n) => n.value === negeriId);

      if (!selectedNegeri1) return [];

      return daerahResult1.value.daerahList
        .filter((daerah) =>
          daerah.kod_daerah.substring(0, 2) === selectedNegeri1.kod &&
          daerah.nama_daerah?.toLowerCase().includes(searchDaerah1.value.toLowerCase())
        )
        .sort((a, b) => a.nama_daerah.localeCompare(b.nama_daerah));
    });

    const handleInput1 = () => {
      executeDaerahQuery1();
    };

    const selectDaerah1 = (daerah) => {
      selectedDaerah1.value = daerah;
      searchDaerah1.value = daerah.nama_daerah;
      form.penempatan_pertama = daerah.nama_daerah;
      isOpen1.value = false;
    };

    const searchDaerah2 = ref("");
    const selectedDaerah2 = ref(null);
    const {
      result: daerahResult2,
      loading: daerahLoading2,
      load: executeDaerahQuery2,
      error: daerahError2,
    } = useLazyQuery(listDaerah);

    watch(daerahResult2, (newResult) => {
      if (newResult && newResult.data && newResult.data.daerahList) {
        console.log("Daerah Result 2:", newResult.data.daerahList);
      } else {
        console.warn("No Daerah List available for Daerah 2");
      }
    });

    // const filteredDaerah2 = computed(() => {
    //   if (!daerahResult2.value || !daerahResult2.value.daerahList) return [];
    //   return daerahResult2.value.daerahList.filter((daerah) =>
    //     daerah.nama_daerah
    //       ?.toLowerCase()
    //       .includes(searchDaerah2.value.toLowerCase())
    //   );
    // });
    const filteredDaerah2 = computed(() => {
      if (!daerahResult2.value || !daerahResult2.value.daerahList) return [];

      const negeriId = form.penempatan_kedua_negeri + '';
      const selectedNegeri2 = combo.negeri.find((n) => n.value === negeriId);

      if (!selectedNegeri2) return [];

      return daerahResult2.value.daerahList
        .filter((daerah) =>
          daerah.kod_daerah.substring(0, 2) === selectedNegeri2.kod &&
          daerah.nama_daerah?.toLowerCase().includes(searchDaerah2.value.toLowerCase())
        )
        .sort((a, b) => a.nama_daerah.localeCompare(b.nama_daerah));
    });

    const handleInput2 = () => {
      executeDaerahQuery2();
    };

    const selectDaerah2 = (daerah) => {
      selectedDaerah2.value = daerah;
      searchDaerah2.value = daerah.nama_daerah;
      form.penempatan_kedua = daerah.nama_daerah;
      isOpen2.value = false;
    };

    // Error handling
    watch(daerahError1, (error) => {
      if (error) {
        console.error("Error loading Daerah 1:", error);
      }
    });

    watch(daerahError2, (error) => {
      if (error) {
        console.error("Error loading Daerah 2:", error);
      }
    });

    onMounted(() => {
      handleInput1();
      handleInput2();
    });

    return {
      BorangPerkhidmatan,
      totalSteps,
      previousStep,
      handleStep,
      formSubmit,
      currentStepIndex,
      borang,
      combo,
      perakuan,
      jantina,
      ageCount,
      checkedPengakuan,
      isPMK,
      formValidation,
      ifJenisPersaraan,
      handleFileUpload,
      handleSijilUpload,
      sijils,
      lampiran,
      getLokasiPenempatanKhas,
      searchDaerah1,
      selectedDaerah1,
      filteredDaerah1,
      handleInput1,
      selectDaerah1,
      searchDaerah2,
      selectedDaerah2,
      filteredDaerah2,
      handleInput2,
      selectDaerah2,
      form,
      isOpen1,
      isOpen2,
      daerahList,
      selectedNegeri,
      selectedDaerah,
      getDaerahList,
      filteredDaerahList,
      handlePsmListEmpty,
      handlePsmNotSelected,
      psmListEmpty,
      psmNotSelected,
      isEditable,
    };
  },
});
